export default function IklimRiskleri() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold">İklim Riskleri</h1>
      <p className="text-gray-600 mt-2">Fiziksel ve geçiş riskleri analizi (Yakında)</p>
    </div>
  );
}
